// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Environment-driven so preview / staging deploys can point at an isolated
// Supabase (a preview branch or the staging project) instead of prod. Falls back
// to the prod project when the env vars are absent, so production builds behave
// exactly as before. Set VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY per
// environment (e.g. in the Cloudflare Pages / Lovable preview build config).
// `||`, NOT `??` (red-team FATAL, 2026-07-14): CI exports these env vars as
// EMPTY STRINGS on non-smoke branches, and `"" ?? fallback` keeps the empty
// string — createClient("") throws at module scope and white-screens every
// preview build. `||` treats empty-as-unset so the prod fallback applies.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://amjwnrglafnzwfrctqoh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFtanducmdsYWZuendmcmN0cW9oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3NDQxMTgsImV4cCI6MjA3MzMyMDExOH0.iggN5wzgjGEQVIpN51ncENj9d8_jKFUw-lnfJ06pmHA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
